import { Alert, Button, Card, Modal, Space, Typography } from 'antd'
import { useStatementRepairMutation } from './statementRepairQueries'
import { getRepairErrorMessage, getRepairQueuedMessage } from './statementRepairModel'

const { Paragraph } = Typography

const StatementRepairSection = () => {
  const [modal, modalContextHolder] = Modal.useModal()
  const mutation = useStatementRepairMutation()

  const handleRepair = () => {
    modal.confirm({
      title: 'Repair statement-paid invoice summaries?',
      okText: 'Repair',
      cancelText: 'Cancel',
      width: 540,
      content: (
        <div>
          <Paragraph style={{ marginBottom: 8 }}>
            This scans every tenant for statements with a pending or completed payment and queues a
            snapshot and summary rebuild for each member invoice.
          </Paragraph>
          <Paragraph style={{ marginBottom: 0 }}>
            The repair is idempotent and safe to re-run.
          </Paragraph>
        </div>
      ),
      onOk: () => {
        mutation.mutate()
      },
    })
  }

  return (
    <Card title="Repair Statement-Paid Invoices" style={{ maxWidth: 760 }}>
      {modalContextHolder}
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          Fixes member invoices that still show a balance after their statement was paid (e.g. after
          a silent QuickBooks export failure). Rebuilds are queued and summaries recompute
          asynchronously as the queue drains.
        </Paragraph>

        <Button type="primary" onClick={handleRepair} loading={mutation.isLoading}>
          Repair invoice summaries
        </Button>

        {mutation.isSuccess && (
          <Alert
            type="success"
            showIcon
            message="Repair queued"
            description={getRepairQueuedMessage(mutation.data)}
          />
        )}

        {mutation.isError && (
          <Alert
            type="error"
            showIcon
            message="Repair failed"
            description={getRepairErrorMessage(mutation.error)}
          />
        )}
      </Space>
    </Card>
  )
}

export default StatementRepairSection
